import React from "react";
import { Link } from "react-router-dom";
import MarketingShell from "../../components/MarketingShell";
import PageMeta from "../../components/PageMeta";
import { ArrowRight, Clock } from "lucide-react";
import { POSTS } from "./posts";

const FORMATTER = new Intl.DateTimeFormat("en-IN", { day: "numeric", month: "long", year: "numeric" });

function PostCard({ post, featured }) {
  return (
    <Link
      to={`/blog/${post.slug}`}
      data-testid={`blog-card-${post.slug}`}
      className={`group block rounded-3xl border border-white/10 bg-white/[0.03] backdrop-blur-xl overflow-hidden hover:bg-white/[0.05] transition-all ${
        featured ? "md:col-span-2" : ""
      }`}
    >
      <div className={`aspect-[16/9] bg-gradient-to-br ${post.cover} relative`}>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/30" />
        <div className="absolute top-4 left-4 px-2.5 py-1 rounded-full bg-black/40 backdrop-blur text-[10px] uppercase tracking-wider text-white font-semibold">
          {post.tag}
        </div>
      </div>
      <div className="p-5 sm:p-6">
        <h2
          className={`font-bold tracking-tight text-white group-hover:text-blue-300 transition-colors ${
            featured ? "text-2xl sm:text-3xl" : "text-lg sm:text-xl"
          }`}
          style={{ fontFamily: "Manrope" }}
        >
          {post.title}
        </h2>
        <p className="mt-2 text-sm text-slate-400 leading-relaxed line-clamp-2">{post.excerpt}</p>
        <div className="mt-4 flex items-center gap-4 text-xs text-slate-500">
          <span>{FORMATTER.format(new Date(post.date))}</span>
          <span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" /> {post.read} read</span>
          <span className="ml-auto inline-flex items-center gap-1 text-blue-400 group-hover:translate-x-0.5 transition-transform">
            Read <ArrowRight className="w-3 h-3" />
          </span>
        </div>
      </div>
    </Link>
  );
}

export default function BlogIndex() {
  const [featured, ...rest] = POSTS;
  return (
    <MarketingShell narrow={false}>
      <PageMeta
        title="Blog · HeDesk"
        description="Stories, product updates, and engineering notes from HeDesk — the clinic management platform for Indian doctors."
        canonical="https://hedesk.help/blog"
      />
      <div className="text-center mb-12">
        <p className="text-xs uppercase tracking-[0.2em] text-blue-400 font-semibold">Blog</p>
        <h1 className="mt-3 text-4xl sm:text-5xl font-bold text-white tracking-tight" style={{ fontFamily: "Manrope" }}>
          Notes from the clinic.
        </h1>
        <p className="mt-4 text-base sm:text-lg text-slate-400 max-w-xl mx-auto">
          Product updates, doctor stories, and engineering deep-dives from the team behind HeDesk.
        </p>
      </div>
      <div className="grid md:grid-cols-2 gap-5" data-testid="blog-grid">
        <PostCard post={featured} featured />
        {rest.map((p) => (
          <PostCard key={p.slug} post={p} />
        ))}
      </div>
    </MarketingShell>
  );
}
